import React from 'react'

import Icon from '../icon'

import * as S from './styles'

import IProps from './props'

const DoctorCard = ({
  name,
  location,
  linkChat,
  linkProfile,
  showIcon,
  hasNewMessage,
  detailTitle = 'Local',
}: IProps) => (
  <S.Container>
    <S.Title>{name}</S.Title>
    <S.Detail>
      <Icon name="map" />
      <S.DetailTitle>
        {detailTitle}
        :
        {' '}
      </S.DetailTitle>
      <S.DetailValue>{location}</S.DetailValue>
    </S.Detail>
    <S.Link to={linkProfile}>
      Ver Perfil
      <Icon name="arrow-right" />
    </S.Link>
    <S.IconContainer to={linkChat}>
      {showIcon && <Icon name="message" />}
      {hasNewMessage && <S.IconTag />}
    </S.IconContainer>
  </S.Container>
)

DoctorCard.defaultProps = {
  showIcon: true,
  hasNewMessage: false,
  linkChat: '',
}

export default DoctorCard
